import { useCallback } from 'react';
import type { FeatureFlagClientConfiguration } from '../../../types/features/featureFlags';
import {
  buildReplaceFeatureFlagStoresRequest,
  buildReplaceFeatureFlagUsersRequest,
} from '../mappers/featureFlagPayloadMapper';
import featureFlagAdminService from '../services/featureFlagAdminService';

export const useFeatureFlagCreateAssignmentSaver = () => useCallback(async (
  featureFlagId: string,
  configuration: FeatureFlagClientConfiguration,
): Promise<void> => {
  if (configuration.globalEnabled) {
    return;
  }

  if (configuration.assignmentTarget === 'store_wise') {
    await featureFlagAdminService.replaceFeatureFlagStores(
      featureFlagId,
      buildReplaceFeatureFlagStoresRequest(configuration.storeIds),
    );
  }

  if (configuration.assignmentTarget === 'user_wise') {
    await featureFlagAdminService.replaceFeatureFlagUsers(
      featureFlagId,
      buildReplaceFeatureFlagUsersRequest(configuration.userIds),
    );
  }
}, []);
